import NotificationActions from '../../actions/NotificationActions';
import Timer from '../../helpers/Timer';
import CONFIG from '../../config';

const updateTimer = new Timer();

export const actions = {
    initNotification() {
        NotificationActions.getNotificationList();

        updateTimer.setTimer({
            maxTime: CONFIG.notificationUpdateTime,
            callback: () => {
                NotificationActions.getNotificationList().then(() => {
                    updateTimer.reset();
                });
            }
        });

    },

    close(id) {
        updateTimer.stop();

        NotificationActions.saveViewNotification({
            'notification_id': id
        }).then(() => {
            updateTimer.reset();
        });
    }
};
